import React, { Component } from 'react';
import Url from 'c-url';
import Cache from 'c-cache';
import { Route } from 'react-router';
// import Home from './views/home';
// import Living from './views/living';
// import Ranking from './views/ranking';
// import Recharge  from './views/recharge';
// import Withdraw from './views/withdraw';
// import Profile from './views/profile';
// import AllHostList from './views/allhostlist';
import About from './views/about';
import News from './views/news';

import VideoPop from './component/video-pop/index';

const cache = new Cache({
    prefix: 'pcuplive'
});

function onEnter (nextState, replace){
    let pathname = nextState.location.pathname;
    let paidfrom = Url.query('paidfrom');

    if (pathname == '/') {
        if (paidfrom) {
            return;
        } else {
            replace('/home')
        }
    }
}

function onEnterPage(nextState, replace){
    return;

    let url = nextState.location.pathname;
    let videoInfo = UP.Global.videoInfo;
    
    if (url.indexOf('living') > -1) {
        VideoPop.destroy();
    } else {
        if (videoInfo && videoInfo.success == 1 && !UP.Global.isEdge) { // 主播正在开播
            VideoPop.create({
                data:  videoInfo
            });
        }
    }
}

// 首页
const Home  = (location, cb) => {
    require.ensure([], require => {
        cb(null, require('./views/home-new').default);
    }, 'home');
};

const AllHostList  = (location, cb) => {
    require.ensure([], require => {
        cb(null, require('./views/allhostlist').default);
    }, 'allhostlist');
};


const Living  = (location, cb) => {
    require.ensure([], require => {
        cb(null, require('./views/living').default);
    }, 'living');
};

const Ranking  = (location, cb) => {
    require.ensure([], require => {
        cb(null, require('./views/ranking').default);
    }, 'ranking');
};

const Recharge  = (location, cb) => {
    require.ensure([], require => {
        cb(null, require('./views/recharge').default);
    }, 'recharge');
};


const Withdraw  = (location, cb) => {
    require.ensure([], require => {
        cb(null, require('./views/withdraw').default);
    }, 'withdraw');
};


const Profile  = (location, cb) => {
    require.ensure([], require => {
        cb(null, require('./views/profile').default);
    }, 'profile');
};


const Activity = (location, cb) =>{
    require.ensure([], require => {
        cb(null, require('./views/activity').default);
    }, 'activity');
};

const GameCenter  = (location, cb) =>{
    require.ensure([], require => {
        cb(null, require('./views/gamecenter').default);
    }, 'gamecenter');
};

const Play = (location, cb) =>{
    require.ensure([], require => {
        cb(null, require('./views/play').default);
    }, 'play');
};


const History = (location, cb) =>{
    require.ensure([], require => {
        cb(null, require('./views/history').default);
    }, 'history');
};

const Show = (location, cb) =>{
    require.ensure([], require => {
        cb(null, require('./views/show').default);
    }, 'showpage');
};

const routes = (
      <Route path="/" onEnter={onEnter} >
            <Route path="home" getComponent={Home} onEnter={onEnterPage}/>
            <Route path="allhostlist/(:type)(/:subtype)" getComponent={AllHostList} onEnter={onEnterPage}/>
            <Route path="living/:hostid/:roomid(/:starId)" getComponent={Living} onEnter={onEnterPage}/>
            <Route path="rank(/:mod)" getComponent={Ranking} onEnter={onEnterPage}/>
            <Route path="recharge" getComponent={Recharge} onEnter={onEnterPage}/>
            <Route path="news" component={News} onEnter={onEnterPage}/>
            <Route path="about" component={About} onEnter={onEnterPage}/>
            <Route path="show" getComponent={Show} onEnter={onEnterPage}/>
            <Route path="activity" getComponent={Activity} onEnter={onEnterPage}/>
            <Route path="gamecenter" getComponent={GameCenter} onEnter={onEnterPage}/>
            <Route path="play" getComponent={Play} onEnter={onEnterPage}/>
            <Route path="withdraw(/:tab)" getComponent={Withdraw} onEnter={onEnterPage}/>
            <Route path="profile(/:tab)(/:uid)" getComponent={Profile} onEnter={onEnterPage}/>
            <Route path="history" getComponent={History} onEnter={onEnterPage}/>
            <Route path="*" getComponent={Home} onEnter={onEnterPage}/>
      </Route>
)

export default routes;


// WEBPACK FOOTER //
// ./js/routes.js